<script>
import {isMobile} from "@js/helpers.ts";

export default {
    name: "OnlyDesktop",
    props: {
        maxSize: {
            type: Number,
            default: 768,
        }
    },
    data() {
        return {
            isMobile: null,
        };
    },
    methods: {
        updateIsMobile() {
            this.isMobile = isMobile(this.maxSize);
        },
    },
    mounted() {
        if (typeof window !== "undefined") {
            this.isMobile = isMobile(this.maxSize);
            window.addEventListener("resize", this.updateIsMobile);
        }
    },
    beforeDestroy() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.updateIsMobile);
        }
    },
};
</script>

<template>
    <div v-show="isMobile !== null && !isMobile">
        <slot/>
    </div>
</template>

<style scoped lang="scss">
</style>
